import { TodoistIntegration } from './Todoist/TodoistIntegration';
import { GoogleDriveIntegration } from './Google/GoogleDrive/GoogleDriveIntegration';
// import { GoogleCalendarIntegration } from './Google/GoogleCalendar/GoogleCalendarIntegration';
import { SlackIntegration } from './Slack/SlackIntegration';
import { GlueIntegration } from '@glueapp/graph-types';
import { GmailIntegration } from './Google/GoogleMail/GmailIntegration';
import { GithubIntegration } from './Github/GithubIntegration';
import { OktaIntegration } from './Okta/OktaIntegration';

export const Integrations: GlueIntegration<any>[] = [
    TodoistIntegration,
    GoogleDriveIntegration,
    GmailIntegration,
    // GoogleCalendarIntegration,
    SlackIntegration,
    GithubIntegration,
    OktaIntegration,
];

export const IntegrationProviderNameDictionary: { [key: string]: GlueIntegration<any> } = Object.fromEntries(
    Integrations.map(integration => [integration.provider, integration]),
);

const setOfIntegrationProviders = new Set(Integrations.map(i => i.provider));
const areAllIntegrationsUnique = setOfIntegrationProviders.size === Integrations.length;
if (!areAllIntegrationsUnique) {
    throw "Integrations aren't unique";
}

export const IntegrationProviders = Integrations.map(integration => integration.provider);
